import { AdditionalApi } from 'api';
import { useAuthMutation } from 'queries/query';

function useCreate() {
  return useAuthMutation(AdditionalApi.post);
}

export default useCreate;
